import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import React from 'react';
import styles from './Channels.module.scss';
import Card from 'component/atom/card/Card';
import whatsappIcon from 'assets/icons/social/whatsapp.svg';
import messengerIcon from 'assets/icons/social/messenger.svg';
import instagramIcon from 'assets/icons/social/instagram.svg';
import teamsIcon from 'assets/icons/social/teams.svg';
import Button from 'component/atom/forms/button/Button';
import * as tableHeader from './factory/channelsHeader';
import TableComponent from 'component/molecules/Table/TableComponent';
const socials = [
  {
    title: 'Whatsapp',
    description:
      'Chat with chatbot instantly on WhatsApp for quick and personalized support at your fingertips.',
    icon: whatsappIcon,
  },
  {
    title: 'Facebook Messenger',
    description:
      'Get connected with chatbot on Facebook Messenger for smooth and intelligent support.',
    icon: messengerIcon,
  },
  {
    title: 'Instagram',
    description:
      'Connect with chatbot on Instagram for instant support and answers to your questions.',
    icon: instagramIcon,
  },
  {
    title: 'Teams',
    description:
      'Improve your workflow with AI-powered help on Microsoft Teams—quick and reliable.',
    icon: teamsIcon,
  },
];
const Channels = () => {
  const renderCardBody = (item) => {
    return (
      <div className={styles['channels-card-body']}>
        <div className={styles['channel-name-container']}>
          <img src={item.icon} />
          <span className={styles['channel-name']}>{item.title}</span>
        </div>
        <span className={styles['channel-description']}>
          {item.description}
        </span>
        <Button type="connect" label="Connect" className={styles['button']} />
      </div>
    );
  };

  return (
    <>
      <SettingsHeader title="Channels" />
      <div className={styles['choose-channels-container']}>
        <span className={styles['choose-channels-title']}>Choose Channels</span>
        <div className={styles['channels-selection']}>
          {socials.map((item, index) => (
            <Card body={renderCardBody(item)} key={index} />
          ))}
        </div>
      </div>
      <TableComponent
        rowKey="id"
        headerData={tableHeader.headerData}
        // isRefetch={refetch}
        // api={{
        //   get: {
        //     url: userEndpoints?.getCompanyUsers,
        //     queryKey: 'companyUsers',
        //   },
        //   delete: { url: userEndpoints?.deleteUser },
        // }}
      />
    </>
  );
};

export default Channels;
